<template>
  <!-- qrStringに値が入れば表示 -->
  <vue-qrcode
    v-if="qrString"
    class="passQR"
    tag="img"
    :value="qrString"
  ></vue-qrcode>
</template>

<script>
export default {
  name: "PFaceQRLink",
  props: {
    qrString: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.passQR {
  width: 60%;
  max-width: 200px;
  margin: auto;
  margin-top: 30px;
  display: block;
}
</style>
